export default () => {
  console.log('INIT LAZYLOAD');
  addEventListener('DOMContentLoaded', (event) => {
    let lazyImages = document.querySelectorAll('img[lazy]');
    let lazyVideos = document.querySelectorAll('video[lazy]');

    let lazyImagesObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove('lazy');
          lazyImagesObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach((lazyImage) => {
      lazyImagesObserver.observe(lazyImage);
    });

    let lazyVideosObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let lazyVideo = entry.target;
          lazyVideo.src = lazyVideo.dataset.src;
          lazyVideo.classList.remove('lazy');
          lazyVideosObserver.unobserve(lazyVideo);
        }
      });
    });
    console.log('lazyVideos', lazyVideos);
    lazyVideos.forEach((lazyVideo) => {
      console.log('lazyVideo', lazyVideo);
      lazyVideosObserver.observe(lazyVideo);
    });

    let slides = document.querySelectorAll('.swiper-slide');
    slides.forEach((slide) => {
      slide.removeAttribute('role');
    });
  });
};
